<template>
  <div style="margin-left: 2px;">
    <Form @submit.native.prevent="preventSubmit" :label-width="250">
      <FormItem label="是否允许取消：">
        <span></span>
        <Select v-if="editStatus" transfer clearable filterable>
          <Option :value="0">允许</Option>
          <Option :value="1">不允许</Option>
        </Select>
      </FormItem>
      <FormItem label="提前取消的天数：" prop="cancelDay">
        <span></span>
        <InputNumber v-if="editStatus" :min="1" :max="100"></InputNumber>
      </FormItem>
      <FormItem label="提前取消的时间（0~24点）：" prop="cancelTime">
        <span></span>
        <InputNumber v-if="editStatus" :min="0" :max="24"></InputNumber>
      </FormItem>
    </Form>
    <Button type="primary" @click="openEditType">{{editStatus ? '编辑取消规则' : '修改取消规则'}}</Button>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          allowCancel: true,
          preCancelDay: 1,
          preCancelTime: 0
        }
      }
    }
  },
  data() {
    return {
      editStatus: false
    }
  },
  methods: {
    openEditType() {
      this.editStatus = !this.editStatus;
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/ota/tujia/hotel-detail/cancel-rules.vue